'use client'
import Box from '@mui/material/Box'
import { FormFieldType } from '@/types'
import { Dispatch, SetStateAction, memo, useCallback } from 'react'
import FormSectionTitle from './FormSectionTitle'
import FormSectionBody from './FormSectionBody'

type FormSectionProps = {
  title: string
  fields: FormFieldType[]
  setFields: Dispatch<SetStateAction<FormFieldType[]>>
  onTitleChange?: (newTitle: string) => void
  onDelete?: () => void
  isDefaultSection?: boolean
  isSectionVisible?: boolean
  onToggleVisibility?: () => void
}

const FormSection = memo<FormSectionProps>(
  ({ title, fields, setFields, onTitleChange, onDelete, isDefaultSection, isSectionVisible = true, onToggleVisibility }) => {
    const handleTitleChange = useCallback(
      (newTitle: string) => {
        onTitleChange?.(newTitle)
      },
      [onTitleChange],
    )

    return (
      <Box sx={{ mb: 4 }}>
        <FormSectionTitle
          title={title}
          onTitleChange={handleTitleChange}
          onDelete={onDelete}
          isDefaultSection={isDefaultSection}
          isSectionVisible={isSectionVisible}
          onToggleVisibility={onToggleVisibility}
        />
        <FormSectionBody fields={fields} setFields={setFields} isDefaultSection={isDefaultSection} isSectionVisible={isSectionVisible} />
      </Box>
    )
  },
)

FormSection.displayName = 'FormSection'

export default FormSection
